import { buildEmailLink, buildPhoneLink } from "../../utils/contact";

function FiliadoCard(){

    const nome = 'Ledupa Rent a Car';
    const cnpj = '00.000.000/0001-00';
    const telefone = '(41) 99999-9999';
    const telefoneLink = buildPhoneLink(telefone);
    const email = 'contato@leduparentacar.com.br';
    const emailLink = buildEmailLink(email);

    return(
        <div class="row row-padding-conteudo row-cols-1 row-cols-md-3 g-3 desktop-hide">
            <div class="col-sm-12 col-md-6 col-lg-4">
                <div class="card">
                    <img src="images/teste.png" class="card-img-top" alt={nome}/>
                    <div class="card-body">
                        <div class="row mb-3"> 
                            <div class="col-8">
                                <h5 class="card-title">{nome}</h5>
                            </div>
                            <div class="col-4">
                                <span class="badge text-bg-success-card">Ativo</span>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3"> 
                        <p class="card-text center-icons">
                            <span class="material-symbols-outlined">gavel</span>{cnpj}
                        </p>
                        <a class="card-text center-icons" href={telefoneLink}>
                            <span class="material-symbols-outlined">phone</span>{telefone}<br/>
                        </a>
                        <a class="card-text center-icons" href={emailLink}>
                            <span class="material-symbols-outlined">mail</span>{email}
                        </a>
                    </div>
                    <div class="row">
                        <button type="button" class="btn btn-desativar">Desativar</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FiliadoCard;
